import $ from 'jquery';
import _ from 'underscore';
import DropDownMenu from './DropDownMenu.js';
import Slip from '../deps/any/slip.js';

/**
 * @typedef {DropDownMenu.Options} OrderingMenu.Options
 *
 * @property {Boolean} [dragDrop=false] Will use the sortable plugin
 * */

/**
 *
 * @type {OrderingMenu.Options}
 */
const defaultOptions = {
    dragDrop: false // will use the slip plugin
};

const KeyCodes = {
    /** @const */UP: 38,
    /** @const */DOWN: 40
};

const arrayInsertAtIndex = function (array, item, atIndex) {

    if (atIndex != null && atIndex >= 0 && atIndex < array.length) {
        array.splice(atIndex, 0, item);
    } else {
        array.push(item);
    }

    return array;
};

const OrderingMenu = DropDownMenu.extend(
    /** @lends OrderingMenu.prototype */
    {

        className: 'ordering-menu',

        /**
         * @constructs
         * @param {OrderingMenu.Options?} options
         * */
        initialize: function (options) {
            let that = this;
            let o = this.o = Object.assign({}, defaultOptions, options);
            o.multi = true;
            o.keyDownHandler = this.onKeyDown;
            o.virtualMinItems = Infinity;

            OrderingMenu.__super__.initialize.call(this, o);

            if (o.dragDrop) {

                let sortableEl = this.$el[0];
                let slip = new Slip(sortableEl, {stopPropagation: false});

                sortableEl.addEventListener('slip:beforeswipe', (e) => e.preventDefault());

                sortableEl.addEventListener('slip:beforewait', (e) => {
                    if (/\bhandle\b/.test(e.target.className) && /\border-drag\b/.test(e.target.parentNode.className))
                        e.preventDefault();
                });

                sortableEl.addEventListener('slip:reorder', (e) => {
                    e.target.parentNode.insertBefore(e.target, e.detail.insertBefore);

                    let item = $(e.target).closest('li').data('item');

                    arrayInsertAtIndex(this.itemsReference(), item, e.detail.spliceIndex);

                    // Trigger event: source-value, dest-value, source-index, dest-index
                    this.trigger('orderchange',
                        item.value,
                        null,
                        e.detail.originalIndex, e.detail.spliceIndex);

                    return false;
                });

                $(sortableEl).on('remove', () => slip.detach());

            }

            this.listenTo(this, 'renderitem', function ($item) {

                if (o.dragDrop) {

                    $item.prepend('<span class="order-drag"><span class="handle" style="display:inline-block;width:30px;height:30px;background:white"></span></span>');

                } else {

                    $item.prepend('<span class="order"><span class="down"></span><span class="up"></span></span>')
                        .on('mouseup', '.order .down', function (event) {
                            that.orderDown($(this).closest('li'));
                            event.stopPropagation();
                        })
                        .on('mouseup', '.order .up', function (event) {
                            that.orderUp($(this).closest('li'));
                            event.stopPropagation();
                        });
                }

            });
        },

        onKeyDown: function (event) {
            if (this._active &&
                (event.which === KeyCodes.UP || event.which === KeyCodes.DOWN) &&
                (event.ctrlKey || event.altKey || event.metaKey)) {

                if (event.which === KeyCodes.UP) {
                    this.orderUp(this._active);
                } else {
                    this.orderDown(this._active);
                }

                event.preventDefault();

                return true;
            }

            return false;
        },

        orderDown: function ($item) {
            let item = $item[0], parent = item.parentNode;
            let index = _.indexOf(parent.childNodes, item), newIndex = index;
            let count = parent.childNodes.length;

            if (count === 1) return; // No change

            let newValue = null;

            if (index === count - 1) {
                newIndex = 0;
                newValue = $(parent.childNodes[newIndex]).data('item').value;
                parent.insertBefore(item, parent.firstChild);
            } else {
                newIndex++;
                newValue = $(parent.childNodes[newIndex]).data('item').value;
                parent.insertBefore(item, item.nextSibling.nextSibling || null);
            }

            arrayInsertAtIndex(this.itemsReference(), item, newIndex);

            // Trigger event: source-value, dest-value, source-index, dest-index
            this.trigger('orderchange', $item.data('item').value, newValue, index, newIndex);
        },

        orderUp: function ($item) {
            let item = $item[0], parent = item.parentNode;
            let index = _.indexOf(parent.childNodes, item), newIndex = index;
            let count = parent.childNodes.length;

            if (count === 1) return; // No change

            let newValue = null;

            if (index === 0) {
                newIndex = count - 1;
                newValue = $(parent.childNodes[newIndex]).data('item').value;
                parent.appendChild(item);
            } else {
                newIndex--;
                newValue = $(parent.childNodes[newIndex]).data('item').value;
                parent.insertBefore(item, item.previousSibling);
            }

            arrayInsertAtIndex(this.itemsReference(), item, newIndex);

            // Trigger event: source-value, dest-value, source-index, dest-index
            this.trigger('orderchange', $item.data('item').value, newValue, index, newIndex);
        }
    }
);

export default OrderingMenu;
